import DashboardIcon from "@mui/icons-material/Dashboard";
import StoreIcon from "@mui/icons-material/Store";

let userMenu = [
    { name: "Dashboard", key: "dashboard", },
    { name: "Manage Users", key: "managerUsers", },
    { name: "Projects", key: "manageProjects" },
];



export { userMenu }